import _ from 'lodash';

import initialState from './initialState';
import snackDefaultOptions from './snackDefaultOptions';

const newSnack = (data: Snack.SnackInput): Snack.SnackInput => ({
  id: Math.random(),
  ...snackDefaultOptions,
  ...data,
});

const addNewSnack = (data: Snack.SnackInput[], snack: Snack.SnackInput): Snack.SnackInput[] => {
  const nextData = [...data.filter((item) => item.id !== snack.id), snack];
  return nextData;
};

export default (state: Snack.SnackInput[] = initialState, action = undefined): Snack.SnackInput[] => {
  if (action.type.endsWith('_ERROR') && action.error && action.payload) {
    if (action.payload.status === 401) {
      return addNewSnack(
        state,
        newSnack({
          id: 'unauthorized',
          severity: 'error',
          summary: 'You are not logged in or your session expired. Please login again.',
        }),
      );
    }

    if (action.payload.status === 403) {
      return addNewSnack(
        state,
        newSnack({
          id: 'nopermission',
          severity: 'error',
          summary: action.payload.message || action.payload.error || 'You have no access permission in this app.',
        }),
      );
    }
  }
  if (action.payload && action.payload.status && action.payload.status === 429) {
    return addNewSnack(
      state,
      newSnack({
        id: 'ratelimit',
        severity: 'error',
        summary: action.payload.message || 'You Reached Rate Limit. Try again after a while.',
      }),
    );
  }
  if (action.meta && action.type.endsWith('_SUCCESS')) {
    if (action.meta.snack_success) {
      let snackData = {
        ...action.meta.snack_success,
        severity: 'success',
      };
      if (action.payload && action.payload.snack) {
        snackData = {
          severity: 'success',
          ...action.payload.snack,
        };
      }
      return [...state, newSnack(snackData)];
    }
  }
  if (action.type.endsWith('_ERROR')) {
    if (action.meta && action.meta.snack_error) {
      return [
        ...state,
        newSnack({
          ...action.meta.snack_error,
          severity: 'error',
        }),
      ];
    }

    if (action.payload.status >= 500) {
      return [
        ...state,
//      if (action.payload.status >= 500) {
        newSnack({
          // the errors from the server should be mapped
          summary: _.isString(action.payload)
              ? action.payload
              : action.payload.message || action.payload.error || "Oops! We couldn't reach the server!",
          severity: 'error',
        })
        //    }
      ];
    }
  }

  switch (action.type) {
    case '@snack/ADD':
      return [...state, newSnack(action.payload)];
    case '@snack/DELETE':
      return state.filter((item) => item.id !== action.payload);
    default:
      return state;
  }
};
